import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "../../../Router/all_routes";
import { useState, useMemo } from "react";
import {
  Link,
  useNavigate,
  useNavigation,
  useSearchParams,
} from "react-router-dom";
import TableTop from "../../../Components/UI/TableTop";
import { useTableSearch } from "../../../core/Operations/useTableSearch";
import { ArrowLeft, Download, Eye, Users } from "react-feather";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { format } from "date-fns";
import Error404 from "../../ErrorPages/error404";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import useTableExport from "core/Operations/useTableExport";
import { Select, Spin, Table } from "antd";
import {
  useResetDeviceMutation,
  useUpdateEmployeeLockStatusMutation,
} from "AppQuries/employee/emp-login";
import {
  useFormattedDepartmentOption,
  useFormattedEmploymentTypeOption,
  useFormattedEmpTypeOption,
} from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import ImagePreview from "Components/UI/Image/ImagePreview";
import { base_path } from "environment";
import { useGetEmpOfferLettersQuery } from "AppQuries/employee/offer-letter";
import { safeDecrypt } from "core/Operations/cryptHelper";
import ImageWithBasePath from "core/img/imagewithbasebath";
const OfferLetter = () => {
  const userData = useSelector(loggedInUser);
  const navigation = useNavigate();
  const route = all_routes;

  const [searchParams, setSearchParams] = useSearchParams();

  const {
    data: offerLetters,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: getOfferLetters,
  } = useGetEmpOfferLettersQuery({
    companyCode: safeDecrypt(searchParams, "companyCode"),
    employeeCode: safeDecrypt(searchParams, "employeeCode"),
  });

  const handleOfferLetter = (action, fullPath) => {
    // const fullPath = `${base_path}/${filePath}`;
    if (action === "view") {
      window.open(fullPath, "_blank");
    } else if (action === "download") {
      const link = document.createElement("a");
      link.href = fullPath;
      link.download = fullPath; // filePath.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Employees Offer Letter</h4>
                <h6>Manage your employee Offer Letter</h6>
              </div>
            </div>
            <div className="page-btn">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="add-new-tooltip">Upload Offer Letter</Tooltip>
                }
              >
                <Link
                  to={`${route.employee}${
                    route.upload_employee_offer_letter
                  }/${safeDecrypt(searchParams, "employeeCode")}`}
                  className="btn btn-added"
                >
                  {/* <ArrowLeft className="me-2" /> */}
                  Upload Offer Letter
                </Link>
              </OverlayTrigger>
            </div>
            &nbsp;
            <div className="page-btn">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="add-new-tooltip">Back to employees</Tooltip>
                }
              >
                <Link
                  to="#"
                  className="btn btn-secondary"
                  onClick={() => navigation(-1)}
                >
                  {/* <ArrowLeft className="me-2" /> */}
                  Back
                </Link>
              </OverlayTrigger>
            </div>
            {/* <div className="page-btn">
              <button
                className="btn btn-defalut"
                type="button"
                onClick={onEmployeeExcelDownload}
              >
                <Upload className="me-2" />
              </button>
            </div> */}
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card border-0">
                <div className="card-header">
                  <h4 className="heade-title">Offer Letters</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    {offerLetters?.map((offerLetter) => (
                      <div
                        className="col-xxl-3 col-xl-4 col-lg-6 col-md-6"
                        key={offerLetter.id}
                      >
                        <div className="employee-grid-profile">
                          <div className="profile-head">
                            <div className="profile-head-action">
                              <span
                                className={`badge ${
                                  offerLetter?.isActive
                                    ? "badge-linesuccess"
                                    : "badge-linedanger"
                                } text-center w-auto me-1`}
                              >
                                {offerLetter?.isActive ? "Active" : "In Active"}
                              </span>
                            </div>
                          </div>
                          <div className="profile-info">
                            <span
                              className="avatar avatar-xxl  me-2 mb-2"
                              style={{
                                border: "1px solid #ddd",
                                padding: "7px",
                                borderRadius: "35px",
                              }}
                            >
                              <ImageWithBasePath
                                src="assets/img/icons/pdf.png"
                                alt="img"
                              />
                            </span>
                          </div>
                          <h5>
                            Created @
                            {format(
                              new Date(offerLetter.createDate),
                              "dd-MM-yyyy"
                            )}
                          </h5>

                          <ul className="department btn-list d-md-flex d-block d-flex justify-content-center">
                            <li>
                              <button
                                className="btn btn-icon btn-primary"
                                type="button"
                                onClick={() =>
                                  handleOfferLetter(
                                    "view",
                                    offerLetter?.offerLetter
                                  )
                                }
                              >
                                <i className="fas fa-eye"></i>
                              </button>
                            </li>
                            <li>
                              <button
                                className="btn btn-icon btn-success"
                                type="button"
                                onClick={() =>
                                  handleOfferLetter(
                                    "download",
                                    offerLetter?.offerLetter
                                  )
                                }
                              >
                                <i className="fas fa-download"></i>
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfferLetter;
